import { render } from "./CoffeeDetail.vue?vue&type=template&id=4407962a"
import script from "./CoffeeDetail.vue?vue&type=script&lang=js"
export * from "./CoffeeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__